import { render } from "./CardTable.vue?vue&type=template&id=f1e2954e"
import script from "./CardTable.vue?vue&type=script&lang=js"
export * from "./CardTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Desktop\\项目\\偏头痛\\vue-notus-main\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__